import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["item", "index"]

  connect() {
    this.element.addEventListener("dragstart", (e) => { this.dragged = e.target.closest("li") })
    this.element.addEventListener("dragover", (e) => {
      e.preventDefault()
      const over = e.target.closest("li")
      if (!over || over === this.dragged) return
      const rect = over.getBoundingClientRect()
      const after = e.clientY > rect.top + rect.height / 2
      after ? over.after(this.dragged) : over.before(this.dragged)
      this.renumber()
    })
    this.renumber()
  }

  up(event) { this.move(event.target.closest("li"), -1) }

  down(event) { this.move(event.target.closest("li"), 1) }

  move(item, delta) {
    const items = this.itemTargets
    const index = items.indexOf(item)
    const target = index + delta
    if (target < 0 || target >= items.length) return
    if (delta < 0) items[target].before(item)
    else items[target].after(item)
    this.renumber()
  }

  renumber() {
    this.indexTargets.forEach((el, position) => { el.textContent = `${position + 1}.` })
  }
}
